import { useState, useCallback } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_MENU_ITEM } from "src/constants/mutations";
import { AddItemInput } from "src/interfaces/menu.interface";

import { MutationCallbacks } from "src/interfaces/menu-items-props.interface";
import { UUID } from "src/types/shared.type";

export const useAddMenuItem = () => {
  const { axBe } = useAxiosInterceptor();
  const  [isAddingMenuItem, setIsAddingMenuItem] = useState(false);

  const addMenuItem = useCallback(async (addMenuItemInput: AddItemInput, callbacks?: MutationCallbacks<{ menuItemCorrelationId: UUID }>) => {
    setIsAddingMenuItem(true);
    try {
      const { data: addedMenuItem } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: ADD_MENU_ITEM,
        variables: {
          addItemInput: addMenuItemInput,
        },
      });
      
      if (addedMenuItem?.errors?.length) {
        throw addedMenuItem?.errors[0];
      }
      
      const menuItemCorrelationId = addedMenuItem.data?.addItem?.correlationId;
      if (!menuItemCorrelationId) {
        throw new Error("Missing correlationId in addItem response");
      }        
      callbacks?.onSuccess?.({ menuItemCorrelationId });
    } catch (err) {
      console.error("Error adding menu item:", err);
      callbacks?.onError?.(err);
    }finally {
      setIsAddingMenuItem(false);
    }
  }, [axBe]);

  return { addMenuItem, isAddingMenuItem };
};

